module.exports = __webpack_public_path__ + "fonts/mem6YaGs126MiZpBA-UFUK0Udc1UAw.bcadc143.woff2";